import { BUYER_ANALYTICS_EVENTS } from "../../constants/automapAnalyticsEvents";
import { trackBuyerEvent } from "../buyerAnalytics";
import { vehiclePriceBucket } from "./buyerPaymentEstimate";

export function trackBuyerPaymentEstimateViewed(slug, extra = {}) {
  trackBuyerEvent(BUYER_ANALYTICS_EVENTS.BUYER_PAYMENT_ESTIMATE_VIEWED, {
    clientViewSlug: slug,
    ...extra,
  });
}

export function trackBuyerPaymentPreferencesEditClicked(slug, extra = {}) {
  trackBuyerEvent(BUYER_ANALYTICS_EVENTS.BUYER_PAYMENT_PREFERENCES_EDIT_CLICKED, {
    clientViewSlug: slug,
    ...extra,
  });
}

export function trackVehicleDetailPaymentEstimateViewed(slug, listingId, estimate, extra = {}) {
  trackBuyerEvent(BUYER_ANALYTICS_EVENTS.VEHICLE_DETAIL_PAYMENT_ESTIMATE_VIEWED, {
    clientViewSlug: slug,
    listingId,
    vehiclePriceBucket: vehiclePriceBucket(estimate?.vehiclePriceCop),
    termMonths: estimate?.termMonths ?? null,
    hasSavedFinancingPrefs: extra.hasSavedFinancingPrefs ?? null,
    source: "detail_page",
    ...extra,
  });
}
